import { categoryIcons, categoryColorableIcons } from 'common/constants';

type CategoryIconsProps = {
    categoryName: string,
    categoryIconFallbackUrl: string,
    className?: string,
    alt?: string,
    /** Custom (user-created) category: render the tinted colourable icon instead of the system one. */
    isCustom?: boolean,
    /** Key into categoryColorableIcons for a custom category (falls back to CustomFolder). */
    icon?: string,
    /** Tint for a custom category's colourable icon. */
    color?: string,
}

export const CategoryIcon = (props: CategoryIconsProps) => {
  const {
    categoryName, categoryIconFallbackUrl, alt = '', isCustom, icon, color, ...rest
  } = props;
  if (isCustom) {
    const ColorableIcon = categoryColorableIcons[icon || 'CustomFolder']
      || categoryColorableIcons.CustomFolder;
    return (
      <ColorableIcon
        color={color}
        {...rest}
      />
    );
  }
  if (categoryIcons[categoryName]) {
    const Icon = categoryIcons[categoryName];
    return (
      <Icon
        {...rest}
      />
    );
  }
  return (
    <img
      src={categoryIconFallbackUrl}
      alt={alt || categoryName || ''}
      {...rest}
    />
  );
};

export default CategoryIcon;
